import styles from "./WPContent.module.css";

interface WPContentT {
    conteudo: string | TrustedHTML,
    css?: string
}

const WPContent = (props: WPContentT) => {
    return (
        <div className={styles.wrapper}>
            {props.css ? <style dangerouslySetInnerHTML={{ __html: props.css }}></style> : ""}
            <div dangerouslySetInnerHTML={{ __html: props.conteudo }}></div>
        </div>
    )
}

export default WPContent;